export default __webpack_public_path__ + "static/media/searchIcon.3996bfd6.svg";